import { constants } from 'src/components/player/src/constants/playerConstants';

import { mixpanelObject } from './analytics';
import { ctaEvent, timeEvent } from './analytics/mixpanel/mixpanelEventsHelper';
import { clearCtaEventsProperty } from './analytics/mixpanel/mixpanelHelper';
import { isGoogleBot } from './botCheck';
import {
  deleteLocalStorage,
  getLocalStorage,
  setLocalStorage,
  setSessionStorage
} from './browserStorageHandler';
import { globalUrlHelper } from './common';
import { FINGER_PRINT_URL } from './constants/ApiConstants';
import {
  BOT_GUEST_TOKEN,
  FINGER_PRINT_TOKEN,
  GUEST_TOKEN
} from './constants/AppConstants';
import { HTTP_HEADER_KEYS } from './constants/HttpMethodsConstants';
import {
  LOGIN_VIA_ACCOUNT_INFO_RELOAD,
  PAYMENT_JOURNEY,
  REDIRECT_URL_TO_CONSUMPTION
} from './constants/localStorageConstants';
import { HeaderLinks } from './constants/RouterConstants';
import {
  PartnerPlatforms,
  HeaderComponentImageAlt,
  APP_USER
} from './constants/stringConstants';
import SimpleStore from '../store/SimpleStore';
import {
  MIXPANEL_ELEMENT,
  MIXPANEL_BUTTON_TYPE,
  MIXPANEL_HEADER,
  MIXPANEL_HORIZONTAL_INDEX,
  MIXPANEL_HEADER_CTA
} from './analytics/mixpanel/mixpanelConstants';

let isRequestedByBot = false;

export const getPlatformName = (forSpapi = false) => {
  let platformName = '';
  const isServer = !(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
  if (
    !isServer &&
    (navigator.userAgent.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|Windows Phone/i
    ) ||
      window.innerWidth <= 480) &&
    !window.navigator.userAgent.toLowerCase().match(/tv/i)
  ) {
    platformName = forSpapi ? 'mobile_web' : 'web_app';
  } else {
    platformName = forSpapi ? 'desktop_web' : 'web_app';
  }
  return platformName;
};

export const getPlatformName_new = () => {
  // TODO
  let platformName = '';
  const isServer = !(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
  if (
    !isServer &&
    (navigator.userAgent?.match(
      /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|Windows Phone/i
    ) ||
      window.innerWidth <= 480) &&
    !window.navigator.userAgent.toLowerCase().match(/tv/i)
  ) {
    platformName = 'mobile_web';
  } else {
    platformName = 'desktop_web';
  }
  return platformName;
};

export const getGuestUserToken = async () => {
  let guestUserToken = getLocalStorage(GUEST_TOKEN);

  if (isRequestedByBot) {
    guestUserToken = BOT_GUEST_TOKEN;
    setLocalStorage(GUEST_TOKEN, guestUserToken);
  }
  // fetch guest token and store to localstorage
  if (!guestUserToken && !isRequestedByBot) {
    const pathname = window?.location?.href;
    const isURLContainsCampaign =
      pathname.includes('utm_source=Affle') ||
      pathname.includes('utm_source=PKPNRM') ||
      pathname.includes('utm_source=adc') ||
      pathname.includes('utm_source=Sanjog') ||
      pathname.includes('utm_source=vComm');
    if (!isURLContainsCampaign) {
      guestUserToken = generateUUID();
    }
    setLocalStorage(GUEST_TOKEN, guestUserToken);
  }

  SimpleStore.set(HTTP_HEADER_KEYS.DEVICE_ID, guestUserToken);
  SimpleStore.set(HTTP_HEADER_KEYS.X_Z5_GUEST_TOKEN, guestUserToken);
  SimpleStore.set(HTTP_HEADER_KEYS.ESK, btoa(generateEskPattern(GUEST_TOKEN)));
  return guestUserToken;
};

export const generateUUID = () => {
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
  return uuid;
};

export const generateEskPattern = (guestToken: string) => {
  // return `${getLocalStorage(guestToken)}__gBQaZLiNdGN9UsCKZaloghz9t9StWLSD__${new Date().getTime()}`;
  return `${getLocalStorage(guestToken)}__${
    process.env.NEXT_PUBLIC_SECRET
  }__${new Date().getTime()}`;
};

/* Get content appropriateAge */
export const getContentAppropriateAge = (settings: any) => {
  const parsedParentalControlV2 = parseJsonObject(settings.parental_control_v2);
  return parsedParentalControlV2 && (parsedParentalControlV2 as any).age_rating;
};

export const parseJsonObject = (data: string) => {
  let parsedData = {};
  try {
    if (typeof data !== 'object' && data !== PartnerPlatforms.TATASKY_PARTNER) {
      parsedData = data && JSON.parse(data);
      return parsedData;
    }
    return data;
  } catch (e) {
    console.error('Error while parsing data', e);
  }
  return data;
};

export const isCountryDropdownEnabled = (hostname = '') => {
  /**
   * process.env.NEXT_PUBLIC_COUNTRY_MENU can return undefined and JSON parsing of undefined or
   * string (fallback value here) will result in Unexpected end of JSON input
   */
  try {
    if (
      typeof window !== 'undefined' &&
      window &&
      window.location.host === 'www.zee5.com'
    ) {
      return false;
    }
    return (
      JSON.parse((process.env.NEXT_PUBLIC_COUNTRY_MENU || '').toLowerCase()) ||
      (!JSON.parse(
        (process.env.NEXT_PUBLIC_COUNTRY_MENU || '').toLowerCase()
      ) &&
        hostname &&
        (hostname === 'globalpwa.zee5.io' ||
          hostname === 'globalpwa.zee5.com' ||
          hostname === 'localhost')) ||
      (!JSON.parse(
        (process.env.NEXT_PUBLIC_COUNTRY_MENU || '').toLowerCase()
      ) &&
        typeof window !== 'undefined' &&
        window &&
        (location.hostname === 'globalpwa.zee5.io' ||
          location.hostname === 'globalpwa.zee5.com' ||
          location.hostname === 'localhost'))
    );
  } catch (error) {
    return false;
  }
};

const trackMixpanelEvents = (element: string) => {
  clearCtaEventsProperty(mixpanelObject);
  mixpanelObject.setProperty(MIXPANEL_ELEMENT, element);
  mixpanelObject.setProperty(MIXPANEL_BUTTON_TYPE, MIXPANEL_HEADER);
  mixpanelObject.setProperty(MIXPANEL_HORIZONTAL_INDEX, '0');
  ctaEvent(false, false, MIXPANEL_HEADER_CTA);

  // mixpanel Initailization end
  timeEvent();
};

export const navigationHandler = (
  link: string,
  element: string,
  event?: React.MouseEvent<HTMLElement, MouseEvent>
) => {
  event?.preventDefault();
  const paymentJourney = getLocalStorage(PAYMENT_JOURNEY);
  if (paymentJourney === APP_USER) return;

  // mixpanel Initailization start
  if (element) {
    trackMixpanelEvents(element);
  }
  if (link === HeaderLinks.SIGN_IN || link === HeaderLinks.REGISTER) {
    // setSessionStorage(REDIRECT_URL_FROM_SUBSCRIPTION, window.location.href);
    setSessionStorage(REDIRECT_URL_TO_CONSUMPTION, window.location.pathname);
    window.location.href = globalUrlHelper(link);
  } else if (
    element === HeaderComponentImageAlt.ZEE5_LOGO &&
    getLocalStorage(LOGIN_VIA_ACCOUNT_INFO_RELOAD)
  ) {
    deleteLocalStorage(LOGIN_VIA_ACCOUNT_INFO_RELOAD);
    window.location.assign(globalUrlHelper(link));
  } else {
    window.location.href = globalUrlHelper(link);
  }
};

export const updateBotValue = (isBot: boolean) =>
  (isRequestedByBot = isBot || isGoogleBot());
